import axios from 'axios'
import qs from 'qs'

export const msNotificationService = ({
  getMSNotificationTemplateList (token) {
    return axios.get('/api/Notification/msnotificationtemplate', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createMSNotificationTemplate (token, leapsMSNotificationTemplateObj) {
    var stringifiedObj = qs.stringify(leapsMSNotificationTemplateObj)
    return axios.post('/api/Notification/msnotificationtemplate', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateMSNotificationTemplate (token, leapsMSNotificationTemplateObj) {
    var stringifiedObj = qs.stringify(leapsMSNotificationTemplateObj)
    return axios.put('/api/Notification/msnotificationtemplate', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteCurrentMSNotificationTemplate (token, msNotificationTemplateId) {
    return axios.delete('/api/Notification/msnotificationtemplate?msNotificationTemplateId=' + msNotificationTemplateId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/ms-notification-service.js